import { Injectable } from "@angular/core";
import { SocketService } from "../../../../../../core/service/socket/socket.service";
import { ChatClipRepHistoryResponse, CreateChatCliRep, ImageUploadResponse, MessageCliRep } from "../interfaces/chat-clip-rep.interface";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ChatCliRepService {

  constructor(
    private socketService: SocketService,
    private http: HttpClient
  ) { }


  joinChat(orderId: number) {
    // console.log('unido a la sala de chat padrino', orderId);
    this.socketService.emit('join-chat-cli-rep', { orderId: orderId });
  }
  getChatHistory(orderId: number): Observable<ChatClipRepHistoryResponse> {
    // console.log('obteniendo historial de chat', orderId);
    this.socketService.emit('get-chat-history-cli-rep', {
      orderId: Number(orderId)
    });
    return new Observable<ChatClipRepHistoryResponse>((observer) => {
      this.socketService.on('order-history', (data: ChatClipRepHistoryResponse) => {
        // console.log('historial de chat', data);
        observer.next(data);
      })
      this.socketService.on('order-history-error', (data) => {
        // console.log('mensaje de chat', data);
        observer.error(data);
      })
    })
    this.socketService.on('order-history-error', (data) => {
      // console.log('mensaje de chat', data);
      return data;
    })
  }


  Typing(data: { senderId: number, receiverId: number, orderId: number, isTyping: boolean }): void {
    // console.log('esta escriendo', data);

    this.socketService.emit('typing-cli-rep', data);
  }

  isTyping(): Observable<{ userId: number, isTyping: boolean }> {
    return new Observable<{ userId: number, isTyping: boolean }>((observer) => {
      const handleTyping = (data: { userId: number, isTyping: boolean }) => {
        // console.log('userTypingCliRep recibido:', data);
        observer.next(data);
      };

      this.socketService.on('userTypingCliRep', handleTyping);

      // Cleanup cuando se desuscribe
      return () => {
        this.socketService.removeListener('userTypingCliRep');
      };
    });
  }

  sendMessage(data: MessageCliRep): void {
    // console.log('enviando mensaje desde el service', data);
    this.socketService.emit('messageCliRep', data);
  }

  // Observable para escuchar nuevos mensajes
  onNewMessage(): Observable<MessageCliRep> {
    return new Observable<MessageCliRep>((observer) => {
      this.socketService.on('messageReceivedCliRep', (data: MessageCliRep) => {
        // console.log('Nuevo mensaje recibido:', data);
        observer.next(data);
      });
    });
  }


  uploadImage(file: File): Observable<ImageUploadResponse> {
    const formData = new FormData();
    formData.append('file', file); // o el nombre que espere tu backend
    return this.http.post<ImageUploadResponse>(`${environment.socketUrl}/image-loader/upload`, formData);
  }

  sendImageMessage(file: File, messageData: Partial<MessageCliRep>): Observable<void> {
    return new Observable<void>((observer) => {
      this.uploadImage(file).subscribe({
        next: (response: ImageUploadResponse) => {
          const sourcePath = response.data.relativePath || response.data.filePath;
          const base = (sourcePath?.split('/').pop() || sourcePath?.split('\\').pop() || sourcePath) as string;
          const imageMessage: MessageCliRep = {
            ...messageData,
            content: '',
            type: 'IMAGE',
            fileName: base,
            fileUrl: `${environment.uploadPath}/image-loader/download/${base}`,
            fileSize: response.data.fileSize,
            mimeType: response.data.fileType,
            timestamp: new Date()
          } as MessageCliRep;

          this.sendMessage(imageMessage);
          observer.next();
          observer.complete();
        },
        error: (error) => {
          console.error('Error uploading image:', error);
          observer.error(error);
        }
      });
    });
  }




}
